function withProfileApiError(fn) {
    const wrappedFunction = (...args) => {
        return fn(...args)
            .then(result => result)
            .catch(error => {
                error.args = JSON.stringify(args);

                // eslint-disable-next-line no-console
                console.error('[withProfileApiError] Error occurred', error);
                throw new ProfileApiError(
                    error,
                    () => wrappedFunction(...args),
                );
            });
    };

    return wrappedFunction;
}

class ProfileApiError extends Error {

    status; // HTTP status code ex) 500
    tryAgain; // function to try API call once again
    code; // Custom code from Profile-faas
    args;

    constructor(error, tryAgain) {
        super(error.message ?? 'Error occurred in Profile Api');
        this.status = error.status;
        this.code = error.code;
        this.args = error.args;
        this.tryAgain = tryAgain;
    }

    get isRecoverableByLogOut() {
        return this.status === 498; // auth token error
    }

    get isRecoverableByTryAgain() {
        return this.status === 401 // cloudflare service unavailable
            || this.status === 504 // cloudflare gateway time out
            || this.status === 524; // cloudflare timeout
    }

    // Possible Errors for this case
    // 422 - general profile-service error
    // 500 - general profile-faas/profile-service error
    // JSON error from response object (no status code)
    // and etc - fallback to this category
    get isRecoverableByRefresh() {
        return !this.isRecoverableByLogOut && !this.isRecoverableByTryAgain;
    }
}

export default withProfileApiError;
export {
    ProfileApiError,
};
